import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  CreateAxiosDefaults,
} from 'axios';

import APP_ENV from './../configs/appEnv';

type Url = string;
export type AxiosReqConfig = AxiosRequestConfig;
type Data = any;

export default class Request {
  _client: AxiosInstance;
  constructor(
    config: CreateAxiosDefaults = {
      baseURL: APP_ENV.API_BASE_URL,
      timeout: APP_ENV.API_TIME_OUT,
      headers: {},
    }
  ) {
    this._client = axios.create({ timeout: APP_ENV.API_TIME_OUT, ...config });
  }
  get client() {
    return this._client;
  }
  async get(url: Url, config?: AxiosReqConfig) {
    return await this._client.get(url, config);
  }

  async post(url: Url, data: Data, config?: AxiosReqConfig) {
    return await this._client.post(url, data, config);
  }

  async patch(url: Url, data: Data, config?: AxiosReqConfig) {
    return await this._client.patch(url, data, config);
  }

  async put(url: Url, data: Data, config?: AxiosReqConfig) {
    return await this._client.put(url, data, config);
  }

  async delete(url: Url, config?: AxiosReqConfig) {
    return await this._client.delete(url, config);
  }
}
